import React from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid, SearchSelect, DatePicker, ChipGroup, makeStyles } from "../../.."; // import PropTypes from "prop-types";

import currencies from "../../../assets/currencies";
import selects from "../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      padding: "20px"
    },
    flex: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "space-between"
    },
    mr30: {
      "margin-right": "30px",
      width: "50%"
    },
    currency: {
      width: "220px"
    },
    estimatedValue: {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      height: "auto"
    },
    w25: {
      width: "25%"
    },
    dates: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "space-between"
    },
    fullWidth: {
      width: "100%"
    }
  };
});

var OpportunityForm = function OpportunityForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode,
      contacts = _ref.contacts,
      type = _ref.type,
      translation = _ref.translation,
      from = _ref.from,
      currency = _ref.currency,
      fromBestPractice = _ref.fromBestPractice;
  // console.log("OpportunityForm currency", currency);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "name",
    name: "name",
    key: "name",
    label: translation ? type === "service" ? translation.inputs.project_name : translation.inputs.opportunity_name : "Oportunity name",
    component: TextField,
    className: classes.fullWidth,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), type !== "service" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "source",
    name: "source",
    key: "source",
    label: translation ? translation.selects.opportunity_source.placeholder : "Opportunity source",
    className: classes.fullWidth,
    component: ChipGroup,
    margin: "normal",
    placeholder: translation ? translation.selects.opportunity_source.placeholder : "Opportunity source",
    value: values.source,
    options: translation ? translation.selects.opportunity_source.items : selects.opportunity_source,
    clickable: mode !== "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    className: classes.dates
  }, type === "service" ? [/*#__PURE__*/React.createElement(Field, {
    name: "dateStart",
    key: "dateStart",
    "data-cy": "dateStart",
    label: translation ? translation.inputs.project_start_date : "Start date",
    className: classes.fullWidth,
    component: DatePicker,
    disablePast: true,
    value: values.dateStart,
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    "data-cy": "dateEnd",
    name: "dateEnd",
    key: "dateEnd",
    label: translation ? translation.inputs.project_finish_date : "End date",
    component: DatePicker,
    disablePast: true,
    value: values.dateEnd,
    disabled: mode === "view"
  })] : /*#__PURE__*/React.createElement(Field, {
    "data-cy": "date",
    name: "date",
    key: "date",
    className: classes.mr30,
    label: translation ? type === "service" ? translation.inputs.project_start_date : translation.inputs.opportunity_date : "Start date (aprox.)",
    component: DatePicker,
    disablePast: true,
    value: values.date,
    disabled: mode === "view"
  })))), mode === "edit" || mode === "view" || from === "contact-single" ? null : values.source === "opportunity" ? null : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "contact",
    name: "contact",
    key: "contact",
    className: classes.fullWidth,
    component: SearchSelect,
    placeholder: translation ? translation.selects.opportunity_contact.placeholder : "Search contact",
    margin: "normal",
    value: values.contact,
    options: contacts,
    clickable: mode !== "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, !fromBestPractice && /*#__PURE__*/React.createElement(Field, {
    "data-cy": "type",
    name: "type",
    key: "type",
    label: translation ? type === "service" ? translation.selects.service_type.placeholder : translation.selects.opportunity_service_type.placeholder : "Service type",
    placeholder: translation ? type === "service" ? translation.selects.service_type.placeholder : translation.selects.opportunity_service_type.placeholder : "Service type",
    className: classes.fullWidth,
    component: ChipGroup,
    margin: "normal",
    value: values.type,
    options: translation ? type === "service" ? translation.selects.service_type.items : translation.selects.opportunity_service_type.items : selects.service_type,
    clickable: mode !== "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "budget",
    name: "budget",
    key: "budget",
    label: translation ? translation.inputs.opportunity_estimated_value : "Budget",
    placeholder: translation ? translation.inputs.opportunity_estimated_value : "Budget",
    component: TextField,
    type: "number",
    margin: "normal",
    value: values.budget,
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "currency",
    name: "currency",
    key: "currency",
    placeholder: translation ? translation.selects.currency.placeholder : "Currency",
    defaultValue: currency,
    component: SearchSelect,
    margin: "normal",
    value: values.currency,
    options: currencies,
    disabled: mode === "view"
  })))), type !== "service" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Field, {
    "data-cy": "statusSells",
    name: "statusSells",
    key: "statusSells",
    placeholder: translation ? translation.selects.opportunity_status.placeholder : "Estado",
    label: translation ? translation.selects.opportunity_status.placeholder : "Estado",
    className: classes.fullWidth,
    component: ChipGroup,
    margin: "normal",
    value: values.statusSells,
    options: translation ? translation.selects.opportunity_status.items : selects.opportunity_status,
    clickable: mode !== "view"
  })));
}; // OpportunityForm.propTypes = {
// 	/** Values coming from Formik*/
// 	values: PropTypes.object,
// 	/** Mode to be render. If 'add' content can be added, if 'edit', previous content would be loaded and can be edited, if 'view' no edit option is allowed */
// 	mode: PropTypes.oneOf([ 'edit', 'view', 'add' ])
// };
// OpportunityForm.defaultProps = {
// 	mode: 'add'
// };


export { OpportunityForm };